<page-header pageTitle="{{pageTitle | translate}}" *ngIf="!isDesignMode && showViewer" style="padding: 10px 10px 0 0;"></page-header>
<mat-horizontal-stepper #stepper [linear]="false" [selected]="selectedStep" [selectedIndex]="selectedStepIndex" *ngIf="!singlePageMode" [hidden]="printFlag">
    <mat-step *ngFor="let group of pageGroups" label="{{group.Name | translate}}"></mat-step>
</mat-horizontal-stepper>
<div class='flex-content' style="padding: 0px;">
    <!-- <app-e-form-viewer id="frmaViewer" 
        *ngIf="showViewer" 
        [configInput]="config">
    </app-e-form-viewer> -->
    <div [ngClass]="{'printHide': printFlag, 'frmaNormal': !printFlag}" style="display: flex; flex:1;">
        <ng-container #frmaContainer></ng-container> 
    </div>
</div>
<div class='flex-footer' *ngIf="showViewer" [hidden]="printFlag">
    <div class='flex-footer-left'>
        <tyl-button image="previous arrow.png" disabledImage="previous arrow disabled.png" label="Previous"  *ngIf="!singlePageMode && page.ID != frmaPagesEnum.Thankyou"
            (clickEvent)="previousClick()" [disabled]="isFP"></tyl-button>
        <!-- <tyl-button image="add.png" label="Add Student" (clickEvent)="addChildClick(true)" *ngIf="page.ID == frmaPagesEnum.StudentsInTheHousehold"></tyl-button> -->
        <tyl-button image="add.png" label="Add Child" (clickEvent)="addChildClick(false)" *ngIf="page.ID == frmaPagesEnum.OtherChildrenInTheHousehold"></tyl-button>
        <tyl-button image="add.png" label="Add Adult" (clickEvent)="addAdultClick()" *ngIf="page.ID == frmaPagesEnum.WhatAdultsLiveInYourHousehold"></tyl-button>
    </div>
    <div class='flex-footer-middle'>
        <tyl-button image="clock.png" [iconWidth]="25" label="Save and Finish Later" (clickEvent)="saveAndFinishLaterClick()"  *ngIf="!singlePageMode && page.ID != frmaPagesEnum.Thankyou"></tyl-button>
    </div>
    <div class='flex-footer-right'>
        <error-prompt [errorList]="errors"></error-prompt>
        <tyl-button image="cancel.png" label="Cancel" (clickEvent)="cancelClick()" *ngIf="page.ID != frmaPagesEnum.Thankyou"></tyl-button>
        <tyl-button image="cancel.png" label="Close" (clickEvent)="closeClick()" *ngIf="page.ID == frmaPagesEnum.Thankyou"></tyl-button>
        <tyl-button image="save.png" label="Submit" (clickEvent)="submitClick()" *ngIf="page.ID == frmaPagesEnum.CertifyandSubmit"></tyl-button>
        <tyl-button image="next arrow.png" disabledImage="next arrow disabled.png" label="Next"  *ngIf="!singlePageMode && !isLP && page.ID != frmaPagesEnum.CertifyandSubmit"
            (clickEvent)="nextClick()"></tyl-button>
    </div>
</div>

    <!-- Student List -->
    <ng-template #knownStudents>
        <div style="display:flex; flex-direction: column;padding-bottom: 20px;">
            <frma-name *ngFor="let student of (application.Children | frmaChildFilter: true: true)" [firstName]="student.FirstName" [middleName]="student.MiddleName" [lastName]="student.LastName" [suffix]="student.SuffixID | frmaSuffix: suffixes"></frma-name>
        </div>
    </ng-template>

    <!-- Other Student List -->
    <ng-template #otherStudentList>
        <ng-container *ngIf="unenrolledChildren.length > 0">
            <div [innerHtml]="unenrolledStudentLabel | mergeField: (isDesignMode || singlePageMode): mergeFieldTrigger" style="margin-bottom: 1em;"></div>
            <div *ngFor="let student of unenrolledChildren" style="padding-left: 12px;">
                <tyl-checkbox id='chkFRMAUnenrolledStudent{{student.ID}}' name='chkFRMAUnenrolledStudent{{student.ID}}' [(checked)]='student.isSelected' (change)="unenrolledStudentClick(student)">
                    <frma-name [firstName]="student.FirstName" [middleName]="student.MiddleName" [lastName]="student.LastName" [suffix]="student.SuffixID | frmaSuffix: suffixes"></frma-name>
                </tyl-checkbox>
            </div>
        </ng-container>
    </ng-template>

    <!-- Signature Checkbox -->
    <ng-template #signatureCheckbox>
        <form>
            <tyl-checkbox #signatureRef id='chkSignature' name='chkSignature' [(checked)]='isSigned' (change)="signatureBoxClick()"></tyl-checkbox>
        </form>
    </ng-template>

    <!-- Signature stamp -->
    <ng-template #signatureStamp>
        <div style="display:flex; flex-direction: column; padding-bottom: 20px;">
            <span>{{application.SignedByName}}</span>
            <span>{{application.SignedDate | date: 'MM/dd/yyyy'}}</span>
        </div>
    </ng-template>

    <!-- Household Programs -->
    <ng-template #householdPrograms>
        <form style="display: flex; flex-direction: column;">
            <ng-container *ngFor="let program of application.Programs">
                <tyl-checkbox [id]='"chkHouseholdProgram" + program.ProgramID' [name]='"chkHouseholdProgram" + program.ProgramID' [(checked)]='program.Selected'>{{program.ProgramID | frmaProgramName: programs: false}}</tyl-checkbox>
                <tyl-form-field label='{{program.ProgramID | frmaProgramName: programs: true}} Case Number' *ngIf="program.Selected" style="margin-left: 30px;">
                    <input #caseNumberRef matInput id='inp{{program.ProgramID}}' name='{{program.ProgramID}}' type='text' [(ngModel)]='program.CaseNumber' required/>
                </tyl-form-field>
            </ng-container>
        </form>
    </ng-template>

    <!-- Foster Care Yes No Buttons -->
    <ng-template #fosterCareButtons>
        <mat-chip-list id="fosterCareChipList" style="margin-bottom: 20px;">
            <mat-chip id="fosterCareYes" [selected]='isFosterFamily == true' (click)="fosterCareChange(true);"><span translate>Yes</span></mat-chip>
            <mat-chip id="fosterCareNo" [selected]='isFosterFamily == false' (click)="fosterCareChange(false);"><span translate>No</span></mat-chip>
        </mat-chip-list>
    </ng-template>

    <!-- Foster Care Student List -->
    <ng-template #fosterCareStudentList>
        <ng-container *ngIf="isFosterFamily">
            <span translate>Which students?</span>
            <tyl-checkbox *ngFor="let child of (application.Children | frmaChildFilter: true: null)" id='chkFoster{{child.FirstName + child.LastName}}' name='chkFoster{{child.FirstName + child.LastName}}' [(checked)]='child.IsFosterChild'>
                <frma-name [firstName]="child.FirstName" [middleName]="child.MiddleName" [lastName]="child.LastName" [suffix]="child.SuffixID | frmaSuffix: suffixes"></frma-name>
            </tyl-checkbox>
        </ng-container>
    </ng-template>

    <!-- McKinney-Vento Buttons -->
    <ng-template #mckinneyVentoButtons>
        <div style="margin-bottom: 20px;">
            <mat-chip-list id="mckinneyVentoButtons" style="margin-bottom: 20px;">
                <mat-chip id="mckinneyVentoYes" [selected]='isMckinneyVento == true' (click)="childProgramChange(true, frmaProgramsEnum.McKinneyVento)"><span translate>Yes</span></mat-chip>
                <mat-chip id="mckinneyVentoNo" [selected]='isMckinneyVento == false' (click)="childProgramChange(false, frmaProgramsEnum.McKinneyVento)"><span translate>No</span></mat-chip>
            </mat-chip-list>
            <ng-container *ngIf="isMckinneyVento">
                <frma-program-student-list [children]="application.Children" [programID]="frmaProgramsEnum.McKinneyVento" [suffixes]="suffixes"></frma-program-student-list>
            </ng-container>
        </div>
    </ng-template>

    <!-- MEP Buttons -->
    <ng-template #mEPButtons>
        <div style="margin-bottom: 20px;">
            <mat-chip-list id="MEPButtons" style="margin-bottom: 20px;">
                <mat-chip id="MEPYes" [selected]='isMEP == true' (click)="childProgramChange(true, frmaProgramsEnum.MEP)"><span translate>Yes</span></mat-chip>
                <mat-chip id="MEPNo" [selected]='isMEP == false' (click)="childProgramChange(false, frmaProgramsEnum.MEP)"><span translate>No</span></mat-chip>
            </mat-chip-list>
            <ng-container *ngIf="isMEP">
                <frma-program-student-list [children]="application.Children" [programID]="frmaProgramsEnum.MEP" [suffixes]="suffixes"></frma-program-student-list>
            </ng-container>
        </div>
    </ng-template>

    <!-- Runnaway Youth Buttons -->
    <ng-template #runawayYouthButtons>
        <div style="margin-bottom: 20px;">
            <mat-chip-list id="RunawayYouthButtons" style="margin-bottom: 20px;">
                <mat-chip id="RunawayYouthYes" [selected]='isRunawayYouth == true' (click)="childProgramChange(true, frmaProgramsEnum.RunawayYouth)"><span translate>Yes</span></mat-chip>
                <mat-chip id="RunawayYouthNo" [selected]='isRunawayYouth == false' (click)="childProgramChange(false, frmaProgramsEnum.RunawayYouth)"><span translate>No</span></mat-chip>
            </mat-chip-list>
            <ng-container *ngIf="isRunawayYouth">
                <frma-program-student-list [children]="application.Children" [programID]="frmaProgramsEnum.RunawayYouth" [suffixes]="suffixes"></frma-program-student-list>
            </ng-container>
        </div>
    </ng-template>

    <!-- Child Program Summary -->
    <ng-template #programSummary>
        <frma-program-summary [children]="application.Children" style="padding-bottom: 10px;"></frma-program-summary>
    </ng-template>

    <!-- Proceed or Submit -->
    <ng-template #proceedOrSubmit>
        <form>
            <div style="margin-bottom: 20px;">
                <strong>Do you want to:</strong>
                <tyl-radio-group style="margin-left: 10px;" arrange="vertical" name="continueOrSubmit" [required]="true"
                [(selected)]="continueOrSubmit" [values]="['Continue', 'Submit']" [labels]="['Provide income information now', 'Submit your application without income information']"
                [ids]="['frmaContinue', 'frmaSubmit']">
                </tyl-radio-group>
            </div>
        </form>
    </ng-template>

    <!-- All Students -->
    <ng-template #allStudents>
        <div style="padding-bottom: 10px;display: flex; flex-direction: column;">
            <frma-name *ngFor="let child of (application.Children | frmaChildFilter: true: null)" [firstName]="child.FirstName" [middleName]="child.MiddleName" [lastName]="child.LastName" [suffix]="child.SuffixID | frmaSuffix: suffixes"></frma-name>
        </div>
    </ng-template>

    <!-- Non-Student Children -->
    <ng-template #nonStudentChildren>
        <ng-container *ngIf="(application.Children | frmaChildFilter: false: null).length > 0">
            <strong translate>and these children</strong>
            <table style="margin: 0 0 20px 20px;">
                <tr *ngFor="let child of (application.Children | frmaChildFilter: false: null)">
                    <td>
                        <frma-name [firstName]="child.FirstName" [middleName]="child.MiddleName" [lastName]="child.LastName" [suffix]="child.SuffixID | frmaSuffix: suffixes"></frma-name>
                    </td>
                    <td style="padding-left: 20px;">
                        <a (click)="deleteChildClick(child)" class="link" translate>Delete</a>
                    </td>
                </tr>
            </table>
        </ng-container>
    </ng-template>

    <!-- Student income list -->
    <ng-template #childHasIncomeList>
        <ng-container *ngFor="let child of application.Children">
            <div *ngIf="!printFlag" [innerHTML]="'Does <strong>[]</strong> have income from any of the sources listed above or any other source?' | translate | frmaFillStudentName: child: suffixes | safeHtml"></div>
            <div *ngIf="printFlag" [innerHTML]="'Does <strong>[]</strong>&nbsp;&nbsp; have income from any of the sources listed above or any other source?' | translate | frmaFillStudentName: child: suffixes | safeHtml"></div>
            <mat-chip-list id="childHasIncomeChipList{{child.ID}}" style="padding-bottom: 15px;">
                <mat-chip id="childHasIncomeYes{{child.ID}}" [selected]='child.HasIncome == true' (click)="child.HasIncome = true;"><span translate>Yes</span></mat-chip>
                <mat-chip id="childHasIncomeNo{{child.ID}}" [selected]='child.HasIncome == false' (click)="child.HasIncome = false;"><span translate>No</span></mat-chip>
            </mat-chip-list>
        </ng-container>
    </ng-template>

    <!-- child income questions -->
    <ng-template #childIncomeQuestions>
        <ng-container *ngFor="let incomeType of childIncomeTypes">
            <frma-child-income-details [childIncomeType]="incomeType" [child]="selectedChild" [app]="application" [selectedPage]="page"></frma-child-income-details>
        </ng-container>
    </ng-template>

    <!-- Known Adults -->
    <ng-template #knownAdults>
        <div style="display:flex; flex-direction: column;padding-bottom: 20px;">
            <frma-name *ngFor="let adult of (application.Adults | frmaAdultFilter: true)" [firstName]="adult.FirstName" [middleName]="adult.MiddleName" [lastName]="adult.LastName" [suffix]="adult.SuffixID | frmaSuffix: suffixes"></frma-name>
        </div>
    </ng-template>

    <!-- Other Adults -->
    <ng-template #otherAdults>
        <ng-container *ngIf="(application.Adults | frmaAdultFilter: false).length > 0">
            <strong translate>and these adults</strong>
            <table style="margin: 0 0 20px 20px;">
                <tr *ngFor="let adult of (application.Adults | frmaAdultFilter: false)">
                    <td>
                        <frma-name [firstName]="adult.FirstName" [middleName]="adult.MiddleName" [lastName]="adult.LastName" [suffix]="adult.SuffixID | frmaSuffix: suffixes"></frma-name>
                    </td>
                    <td style="padding-left: 20px;">
                        <a (click)="deleteAdultClick(adult)" class="link" translate>Delete</a>
                    </td>
                </tr>
            </table>
        </ng-container>
    </ng-template>

    <!-- Adult income questions -->
    <ng-template #adultIncomeTypeQuestions>
        <ul style="padding-left: 15px;">
            <li *ngFor="let incomeType of adultIncomeTypes" style="padding-bottom: 10px;">
                <span>{{incomeType.Question | translate | mergeField: false: mergeFieldTrigger }}</span>
                <mat-chip-list id="adultIncomeQuestionsChipList{{incomeType.ID}}" style="padding-bottom: 15px;">
                    <mat-chip id="adultIncomeQuestionsYes{{incomeType.ID}}" [selected]='selectedAdultdHasIncome(incomeType.ID) == true' (click)="adultHasIncomeClick(incomeType.ID, true)"><span translate>Yes</span></mat-chip>
                    <mat-chip id="adultIncomeQuestionsNo{{incomeType.ID}}" [selected]='selectedAdultdHasIncome(incomeType.ID) == false' (click)="adultHasIncomeClick(incomeType.ID, false)"><span translate>No</span></mat-chip>
                </mat-chip-list>        
            </li>
        </ul>
    </ng-template>

    <!-- Adult income sub-type questions -->
    <ng-template #adultIncomeSubTypeQuestions>
        <ul style="padding-left: 15px;">
            <li *ngFor="let incomeType of adultIncomeSubTypes" style="padding-bottom: 10px;">
                <div> <!-- this div is required for Firefox.  Otherwise the bullet does not line up with the list item-->
                    <frma-adult-income-details [adultIncomeSubType]="incomeType" [adult]="selectedAdult" 
                        [showMilitaryAdditionalText]="incomeType.ID == 1 && selectedAdult && selectedAdult.IsDeployed" [app]="application" [selectedPage]="page">
                    </frma-adult-income-details>  
                </div>    
            </li>
        </ul>
    </ng-template>

    <!-- Is Deployed -->
    <ng-template #isDeployed>
        <span>{{'Is [] currently deployed?' | translate | frmaFillAdultName: selectedAdult: suffixes }}</span>
        <mat-chip-list id="isDeployedQuestionsChipList" style="padding-bottom: 15px;">
            <mat-chip id="isDeployedQuestionsYes" [selected]='selectedAdult.IsDeployed == true' (click)="selectedAdult.IsDeployed = true;"><span translate>Yes</span></mat-chip>
            <mat-chip id="isDeployedQuestionsNo" [selected]='selectedAdult.IsDeployed == false' (click)="selectedAdult.IsDeployed = false;"><span translate>No</span></mat-chip>
        </mat-chip-list>  
    </ng-template>

    <!-- SSN -->
    <ng-template #ssn>
        <form>
            <tyl-form-field label='Last Four Digits'>
                <input #ssnRef matInput id='inpSSN' name='SSN' type='text' [(ngModel)]='application.LastFourSSN' numbers-only [required]="!application.NoSSN" maxlength="4"/>
            </tyl-form-field>
        </form>
    </ng-template>

    <!-- SSN -->
    <ng-template #noSSN>
        <tyl-checkbox id='chkNoSSN' name='chkNoSSN' [(checked)]='application.NoSSN' style="padding-bottom: 10px;"><span translate>No SSN</span></tyl-checkbox>
    </ng-template>

    <!-- Sharing Information Grid-->
    <ng-template #sharingInformationGrid>
        <div *ngIf="!mealApplicationConfidentiallyWaiverLookups || mealApplicationConfidentiallyWaiverLookups.length == 0" translate>
            To save you time and effort, the information you gave on this application may be shared with other programs for which your child(ren) may qualify.
        </div>
        <ng-container *ngIf="mealApplicationConfidentiallyWaiverLookups && mealApplicationConfidentiallyWaiverLookups.length > 0">
            <div translate style="padding-bottom: 10px;">
                To save you time and effort, the information you gave on this application may be shared with other programs for which your child(ren) may qualify.  For the following programs,
                we must have your permission to share your information.  Your answers here will not change whether your children get free or reduced-price meals.
            </div>
            <div translate style="padding-bottom: 10px;">
                Do you want school officials to share information from this Free/Reduced Meal Application with the following programs?
            </div>
            <mat-table #table [dataSource]="application.InfoSharing" id="tblFRMAInfoSharing">        
                <ng-container matColumnDef="ProgramName">
                    <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.ProgramName}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="No">
                    <mat-header-cell *matHeaderCellDef> <span translate>No</span> 
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element"> 
                        <mat-radio-button id="rbInfoSharingNo{{element.WaiverProgramID}}" name="rbInfoSharing{{element.WaiverProgramID}}" [checked]="element.ShareWith == 'none'" (click)="shareWithRadioClick(element, 'none')">
                        </mat-radio-button>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Yes">
                    <mat-header-cell *matHeaderCellDef> <span translate>Yes</span> 
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element"> 
                        <mat-radio-button id="rbInfoSharingYes{{element.WaiverProgramID}}" name="rbInfoSharing{{element.WaiverProgramID}}" [checked]="element.ShareWith == 'all'" (click)="shareWithRadioClick(element, 'all')">
                        </mat-radio-button>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Selected">
                    <mat-header-cell *matHeaderCellDef> <span translate>Yes, but only for these students</span> 
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element"> 
                        <div style="display:flex">
                            <mat-radio-button id="rbInfoSharingSelected{{element.WaiverProgramID}}" name="rbInfoSharing{{element.WaiverProgramID}}" [checked]="element.ShareWith == 'selected'" (click)="shareWithRadioClick(element, 'selected')">
                            </mat-radio-button>
                        </div>
                        <div style="display:flex; flex-direction: column;margin-top: -4px;">
                            <tyl-checkbox *ngFor="let student of (application.Children | frmaChildFilter: true: null)" id='chkProgram{{element.WaiverProgramID}}Student{{student.ID}}' 
                                name='chkProgram{{element.WaiverProgramID}}Student{{student.ID}}' [checked]='canShareStudentInfo(element, student)' (change)="shareInfoClick(element, student)"
                                [disabled]="element.ShareWith != 'selected'">
                                <frma-name [firstName]="student.FirstName" [middleName]="student.MiddleName" [lastName]="student.LastName" [suffix]="student.SuffixID | frmaSuffix: suffixes"></frma-name>
                            </tyl-checkbox>
                        </div>
                    </mat-cell>
                </ng-container>
            
                <mat-header-row *matHeaderRowDef="infoSharingColumns; sticky: true"></mat-header-row>
                <mat-row *matRowDef="let row; columns: infoSharingColumns; let i = renderIndex;" id="tblFRMAInfoSharingDataRow{{i}}" style="align-items: flex-start;">
                </mat-row>
            </mat-table>
        </ng-container>
    </ng-template>

    <!-- summary -->
    <ng-template #summary>
        <form>
            <!-- Students in household - always shows -->
        <div class="summarySection">
            <div class="blueText">
                <span translate>Students Attending</span> {{districtName}}
            </div>
            <div class="summarySubSection">
                <div *ngFor="let student of (application.Children | frmaChildFilter: true: null)">
                    <frma-name [firstName]="student.FirstName" [middleName]="student.MiddleName" [lastName]="student.LastName" [suffix]="student.SuffixID | frmaSuffix: suffixes"></frma-name>
                    <!-- Details only show if there are no household programs selected -->
                    <ul *ngIf="(application.Programs | frmaSelectedPrograms).length == 0">
                        <li translate *ngIf="student.IsFosterChild">Foster child</li>
                        <!-- List Student Programs -->
                        <li *ngFor="let program of (student.Programs | frmaChildSelectedPrograms)">{{program.ProgramID | frmaProgramName: programs: true}}</li>
                        <!-- If every child in the household is not coverd by a program and is not a foster child, then show their income -->
                        <ng-container *ngIf="(application.Children | frmaAllStudentsInProgram) == false">
                            <li *ngFor="let income of student.Income">{{income.ChildIncomeTypeID | frmaChildIncomeType: childIncomeTypes: true | translate}} - ${{income.Amount | number: '1.2-2'}} {{income.Frequency | translate}}
                                <ng-container *ngIf="income.Frequency == 'hourly'">
                                    &nbsp;x {{income.Hours}} <span translate>hours per</span> {{income.Per | translate}} = ${{(income.Amount * income.Hours) | number: '1.2-2'}} <span translate>&nbsp;per</span> {{income.Per | translate}}
                                </ng-container>
                            </li> 
                        </ng-container>
                    </ul>
                </div>
            </div>
        </div>
        <!-- The Other Children and Adult sections only show if no hosehold programs are selcted and at least one child in the household is neither a foster child nor has a program selected -->
        <ng-container *ngIf="(application.Programs | frmaSelectedPrograms).length == 0 && (application.Children | frmaAllStudentsInProgram) == false">
            <!-- Other Children - only shows if there are not-student children in the household-->
            <div class="summarySection"
                *ngIf="(application.Children | frmaChildFilter: false: null).length > 0">
                <div class="blueText">
                    <span translate>Other Children</span>
                </div>
                <div class="summarySubSection">
                    <div *ngFor="let student of (application.Children | frmaChildFilter: false: null)">
                        <frma-name [firstName]="student.FirstName" [middleName]="student.MiddleName" [lastName]="student.LastName" [suffix]="student.SuffixID | frmaSuffix: suffixes"></frma-name>
                        <ul *ngIf="(application.Programs | frmaSelectedPrograms).length == 0">
                            <li translate *ngIf="student.IsFosterChild">Foster child</li>
                            <!-- List Student Programs -->
                            <li *ngFor="let program of (student.Programs | frmaChildSelectedPrograms)">{{program.ProgramID | frmaProgramName: programs: true}}</li>
                            <!-- If every child in the household is not coverd by a program and is not a foster child, then show their income -->
                            <ng-container *ngIf="(application.Children | frmaAllStudentsInProgram) == false">
                                <li *ngFor="let income of student.Income">{{income.ChildIncomeTypeID | frmaChildIncomeType: childIncomeTypes: true | translate}} - ${{income.Amount | number: '1.2-2'}} {{income.Frequency | translate}}
                                    <ng-container *ngIf="income.Frequency == 'hourly'">
                                        &nbsp;x {{income.Hours}} <span translate>hours per</span> {{income.Per | translate}} = ${{(income.Amount * income.Hours) | number: '1.2-2'}} <span translate>&nbsp;per</span> {{income.Per | translate}}
                                    </ng-container>
                                </li> 
                            </ng-container>
                        </ul>
                    </div>
                </div>
            </div>
            <!-- Adults -->
            <div class="summarySection">
                <div class="blueText">
                    <span translate>Adults</span>
                </div>
                <div class="summarySubSection">
                    <div *ngFor="let adult of application.Adults">
                        <frma-name [firstName]="adult.FirstName" [middleName]="adult.MiddleName" [lastName]="adult.LastName" [suffix]="adult.SuffixID | frmaSuffix: suffixes"></frma-name>
                        <ul *ngIf="adult.Income && adult.Income.length > 0">
                            <li *ngFor="let income of adult.Income">{{income.AdultIncomeSubTypeID | frmaAdultIncomeSubTypeName: allAdultIncomeSubTypes: true | translate}} - ${{income.Amount | number: '1.2-2'}} {{income.Frequency | translate}}
                                <ng-container *ngIf="income.Frequency == 'hourly'">
                                    &nbsp;x {{income.Hours}} <span translate>hours per</span> {{income.Per | translate}} = ${{(income.Amount * income.Hours) | number: '1.2-2'}} <span translate>&nbsp;per</span> {{income.Per | translate}}
                                </ng-container>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="summarySection">
                <div class="blueText">
                    <span translate>Total Household Income</span>
                </div>
                <div class="summarySubSection">
                    <strong>{{application | frmaAnnualHouseholdIncome}} <span translate>per year</span></strong>
                    <div style="padding-top: 10px;" translate>
                        NOTE: We calculated this number by converting all the income you reported into an annual amount.  Remember, this should be a gross amount, so it will be more than what you receive as take-home pay.
                    </div>
                </div>
            </div>
        </ng-container>
        <div class="summarySection" *ngIf="(application.Programs | frmaSelectedPrograms).length > 0">
            <div class="blueText">
                <span translate>Assistance Program Case Numbers</span>
            </div>
            <div class="summarySubSection">
                <div *ngFor="let program of (application.Programs | frmaSelectedPrograms)">{{program.ProgramID | frmaProgramName: programs: false}} - #{{program.CaseNumber}}</div>
            </div>
        </div>


        <div class="summarySection">
            <tyl-checkbox #iCertifyRef id='chkFRMAProgramCertify' name='chkFRMAProgramCertify' [(checked)]='isCertified' (change)="certifiedBoxClick()">
                <!-- Household Program confirmation - shows when a household program is selected-->
                <ng-container *ngIf="(application.Programs | frmaSelectedPrograms).length > 0">
                    <strong translate>I certify* that my household participates in </strong>
                    <strong class="blueText">{{application.Programs | frmaSummaryProgramString: programs}}</strong>
                </ng-container>
                <ng-container *ngIf="(application.Programs | frmaSelectedPrograms).length == 0">
                    <!-- Generic confirmation - shows when a household program is not selected and all students are either foster children or have a program selected-->
                    <ng-container *ngIf="(application.Children | frmaAllStudentsInProgram) == true">
                        <strong translate>I certify* that the information provided on this page is correct to the best of my knowledge.</strong>
                    </ng-container>
                    <!-- Income confirmation - shows when a household program is not selected and at least one child in the household is neither a foster child nor has a program selected-->
                    <ng-container *ngIf="(application.Children | frmaAllStudentsInProgram) == false">
                        <strong><span translate>I certify* that</span>&nbsp;<span class="blueText">{{application.Children.length + application.Adults.length}} <span translate [ngStyle]="{'padding-right': printFlag ? '5px' : ''}">PEOPLE</span></span>&nbsp;<span [ngStyle]="{'margin-right': printFlag ? '26px' : ''}" translate>are in my household and that our household income is about</span>&nbsp;<span [ngStyle]="{'margin-left': printFlag ? '' : ''}" class="blueText">{{application | frmaAnnualHouseholdIncome}} <span translate>PER YEAR</span></span>.</strong>
                    </ng-container>
                </ng-container>
            </tyl-checkbox>
        </div>
        </form>
    </ng-template>
